import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
  },
  action
) {
  switch (action.type) {
    case homeConstants.VALIDATE_COUPON_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.VALIDATE_COUPON_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.VALIDATE_COUPON_FAILURE:
      return {
        data: null,
        isProgress: false,
      };
    case homeConstants.RESET_DELETE_COUPON_INFO:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
